import React from 'react';
import { GenreGameAndAffinitySelectType } from '../../types';
import LogicSelect from '../LogicSelect';
import GenreGameListSelect from '../GenreGameListSelect';
import GameAffinitySelect from '../GameAffinitySelect';
import './index.scss';

export default function GenreGameAndAffinitySelect(
  props: GenreGameAndAffinitySelectType,
) {
  return (
    <div className="genre-game-and-affinity-select-wrapper">
      <GenreGameListSelect {...props}></GenreGameListSelect>
      <LogicSelect
        {...props}
        defaultKey="affinity_type"
        pointKey="GamesWithAffinity"
      ></LogicSelect>
      <GameAffinitySelect {...props} />
    </div>
  );
}
